<template>

  <div class="h-100 d-flex">

    <div class="white px-0 h-100" id="cl" :class="{'no-fav':!favoriteFeature}">

      <div class="search-form">


        <div class="search-input">

          <input v-model="query" v-on:keyup="sbTop" type="text" class="form-control search"
                 placeholder="Search authenticator"/>

          <button class="btn" type="button" aria-haspopup="true" aria-expanded="false"
                  v-on:click="clearQuery">
            <magnify-icon v-if="!query"/>
            <close-circle-icon v-if="query"/>
          </button>


        </div>
        <p class="form-inline mb-0">
          <button v-if="!offlineMode" class="btn btn-link btn-sm auth-reload" :disabled="dispatching"
                  @click="refreshAuthenticators">
            <reload-icon/>
            Reload authenticators
          </button>

          <small class="auth-count">

            <span v-if="query">
                <b>{{filteredSecrets.length}}</b> of the
            </span>
            <b v-if="!loading">{{secretsCount}} authenticators</b>

            <input type="hidden" id="code" :value="'key'">
          </small>
        </p>
        <div class="tabs" v-if="favoriteFeature">
          <a href="#" class="tab" @click="setFilter(1)" :class="{'active':filter==1}">Favorited</a>
          <a href="#" class="tab" @click="setFilter(0)" :class="{'active':filter==0}">All</a>
        </div>
      </div>

      <div v-if="!loading" id="ccl" class="list-group-flush sidenav scrollbar scrollbar-primary d-block">

        <div :style="{height: sb}">

          <p v-if="slicedSecrets.length == 0" class="p-4 purple lighten-5">
            There are no authenticators matching this search query.
          </p>

          <span class="d-block grey lighten-4" :style="{height : beforeHeight }"></span>

          <ul class="d-block" :style="{height : currentHeight }">

            <authenticator v-for="secret in slicedSecrets" :secretId="secret.id"
                           :key="secret.id" :time="time"
            >

            </authenticator>

          </ul>
        </div>

      </div>

    </div>

  </div>

</template>

<script>
  import _ from 'lodash';
  import {mapActions, mapGetters} from 'vuex';

  import EyeIcon from "vue-material-design-icons/Eye";
  import EyeOffIcon from "vue-material-design-icons/EyeOff";
  import ContentCopyIcon from "vue-material-design-icons/ContentCopy";
  import LoadingIcon from "vue-material-design-icons/Loading";
  import ReloadIcon from "vue-material-design-icons/Reload";
  import MagnifyIcon from "vue-material-design-icons/Magnify";
  import CloseCircleIcon from "vue-material-design-icons/CloseCircle";

  import * as Toastr from 'toastr';
  import OpenInNewIcon from "../../../node_modules/vue-material-design-icons/OpenInNew.vue";
  import Authenticator from "./Authenticator.vue";

  Toastr.options.timeout = 1500;

  export default {
    name: 'Authenticators',
    components: {
      Authenticator,
      OpenInNewIcon,
      EyeIcon,
      EyeOffIcon,
      ContentCopyIcon,
      LoadingIcon,
      ReloadIcon,
      MagnifyIcon,
      CloseCircleIcon,
    },
    data() {
      return {
        time: 0,
        dispatched: {},
        query: '',
        queryHasResult: true,
        sortSelected: 'name',
        sortOptions: [
          {label: 'Name', value: 'name'},
        ],
        sortBy: 0,
        sortByOptions: [
          {label: 'A-Z', value: 0},
          {label: 'Z-A', value: 1},
        ],
        create: false,
        edit: false,
        loading: false,
        interval: null,
        dispatching: false,
        filter: 0,
        scrollbar: {
          totalHeight: 0,
          currentHeight: 0,
          beforeHeight: 0,
          afterHeight: 0,
          scrolled: 0,
          total: 0,
          range: 5,
          show: 15,
          current: 0,
          first: 0,
          last: 15,
          from: 0,
          to: 15,
          magic: 118,
        }
      };
    },
    computed: {
      ...mapGetters({
        url: 'auth/url',
        offlineMode: 'auth/offlineMode',
        secrets: 'authenticators/all',
        templateId: 'authenticators/templateId',
        personalFolderId: 'authenticators/personalFolderId',
        showOtp: 'settings/showOtp',
        okey: 'settings/okey',
        favorites: 'authenticators/favorites',
      }),
      favoriteFeature() {
        return (this.okey || this.favorites.length >= 1) || !this.offlineMode;
        // return (!this.offlineMode && this.okey && this.personalFolderId) || this.favorites.length >= 1;
      },
      secretsCount() {
        return Object.keys(this.secrets).length;
      },
      sb() {
        this.calcScroll();
        return this.scrollbar.totalHeight + "px";
      },
      currentHeight() {
        return this.scrollbar.currentHeight + "px";
      },
      beforeHeight() {
        return this.scrollbar.beforeHeight + "px";
      },
      afterHeight() {
        return this.scrollbar.afterHeight + "px";
      },
      filteredSecrets() {
        let list = this.secrets;
        if (this.query && list) {
          list = _.filter(list, secret => {
            var name = (secret.name.toLowerCase()
              .indexOf(this.query.toLowerCase()) !== -1);
            if (name) {
              return true;
            }
          });
        }
        if (list && this.filter === 1) {
          list = _.filter(list, secret => {
            return (this.favorites.includes(secret.id));
          });
        }
        list = _.sortBy(list, el => el[this.sortSelected].toLowerCase());
        list.forEach(secret => {
          if (!secret.items && !this.dispatched[secret.id]) {
            this.dispatched[secret.id] = true;
            this.$store.dispatch('authenticators/getAuthenticator', secret.id);
          }
        });
        if (this.sortBy) list.reverse();
        return list;
      },
      slicedSecrets() {
        return this.filteredSecrets.slice(this.scrollbar.from, this.scrollbar.to);
      },

    },
    methods: {
      ...mapActions({
        getAuthenticator: 'authenticators/getAuthenticator',
        generateOtp: 'authenticators/generateOtp',
        setLoading: 'loading/setLoading',
        setDelayedFeedback: 'feedback/setDelayedFeedback',
        toggleShowOtp: 'authenticators/toggleShowOtp',
        getPreferences: 'authenticators/getPreferences',
        getCompanyPreferences: 'authenticators/getCompanyPreferences',
        getPersonalFolderId: 'authenticators/getPersonalFolderId',
      }),
      setFilter(id) {
        this.filter = id;
        this.calcScroll();
      },
      secretUrl(id) {
        return this.url + '/SecretView.aspx?secretid=' + id;
      },
      refreshAuthenticators() {
        this.dispatching = true;
        this.$store.dispatch('authenticators/clearAll');
        this.$store.dispatch('asyncData')
          .then(() => {
            this.dispatching = false;
          });
        this.filter = 0;
        this.dispatched = {};
      },
      timer() {
        var epoch = Math.round(new Date().getTime() / 1000.0);
        var countDown = 30 - (epoch % 30);
        this.time = countDown;
        return countDown;
      },
      copy(id) {
        if (this.secrets[id].otp === 'undefined') {
          Toastr.error('Unable to copy.');
          return false;
        }
        return this.clip(this.secrets[id].otp);
      },
      clip(str) {
        const el = document.createElement('textarea');
        el.value = str;
        el.setAttribute('readonly', '');
        el.style.position = 'absolute';
        el.style.left = '-9999px';
        document.body.appendChild(el);
        const selected = document.getSelection().rangeCount > 0 ? document.getSelection()
          .getRangeAt(0) : false;
        el.select();
        document.execCommand('copy');
        document.body.removeChild(el);
        if (selected) {
          document.getSelection()
            .removeAllRanges();
          document.getSelection()
            .addRange(selected);
          Toastr.success('One Time Password copied');
        }
      },
      clearQuery() {
        if (this.query) {
          this.query = '';
        }
      },
      scrollToId(id) {
        var pos = _.findLastIndex(_.toArray(this.filteredSecrets), {id});
        document.getElementById('ccl').scrollTop = this.scrollbar.magic * pos;
      },
      calcScroll: _.debounce(function() {
        let sb = this.scrollbar;
        let r = sb.range + sb.show;

        sb.total = this.filteredSecrets.length;
        if (sb.total > sb.current) {
          sb.current = Math.floor(sb.scrolled / sb.magic);
        } else {
          sb.current = 0;
        }

        sb.first = (sb.current > r ? sb.current - r : 0);
        sb.last = r + sb.first;

        sb.from = (sb.current >= sb.range ? sb.current - sb.range : 0);
        sb.to = r + sb.from;

        sb.totalHeight = sb.total * sb.magic;
        sb.currentHeight = (sb.from ? sb.total - sb.from : (sb.current > r ? r : sb.total) * sb.magic);
        sb.beforeHeight = (this.create ? (sb.from * sb.magic) - sb.magic : sb.from * sb.magic);
      }, 150),
      sbTop() {
        document.getElementById('ccl').scrollTop = 0;
        this.scrollbar.scrolled = 0;
        setTimeout(() => {
          this.calcScroll();
        }, 500);
      },
      scroll(h) {
        this.scrollbar.scrolled = h;
        this.calcScroll();
      },
    },
    mounted() {
      if (!this.templateId) {
        this.getPreferences(true)
          .then(resp => {
            if (resp) {
              this.refreshAuthenticators();
            } else {
              this.getCompanyPreferences()
                .then(resp => {
                  if (resp < 4) {
                    this.setDelayedFeedback({
                      feedback: {
                        message: 'Almost there, there is a configuration to complete',
                        type: 'info'
                      }
                    });
                    this.$router.push('settings');
                  } else {
                    this.refreshAuthenticators();
                  }
                });
            }
          });
        return;
      }
      if (!this.personalFolderId) {
        this.getPersonalFolderId();
      }

      if (this.favorites && this.favorites.length >= 1) {
        this.filter = 1;
      }

      this.interval = setInterval(function () {
        this.timer();
      }.bind(this), 1000);

      let ccl = document.getElementById('ccl');
      ccl.onscroll = () => {
        this.scroll(ccl.scrollTop);
      };
      this.calcScroll();
    },
    created() {
      if (this.templateId !== false && !this.offlineMode && this.secretsCount <= 0 && !this.offlineMode) {
        this.$store.dispatch('asyncData');
      }
      if (this.interval === null) {
        this.interval = setInterval(function () {
          this.timer();
        }.bind(this), 1000);
      }
      this.timer();
      this.calcScroll();
    },
    beforeDestroy() {
      clearInterval(this.interval);
    }
  };
</script>



// WEBPACK FOOTER //
// src/components/pages/Authenticators.vue